export const sortByStringAsc = (a: string, b: string) => a.localeCompare(b);

export const sortByStringDesc = (a: string, b: string) => b.localeCompare(a);

export const sortByNumberAsc = (a: number, b: number) => a - b;

export const sortByNumberDesc = (a: number, b: number) => b - a;

export const sortByDateAsc = (a: string, b: string) =>
  new Date(a).getTime() - new Date(b).getTime();

export const sortByDateDesc = (a: string, b: string) =>
  new Date(b).getTime() - new Date(a).getTime();
